import React from 'react';

import { formatStringToDate } from 'utils/formatters';

export const HistorySection = ({ user }) => {
  const { createdDate, updatedDate, deactivatedDate } = user;

  return (
    <div>
      <div
        id="createdDate"
        className="Heading6 text-blue"
        data-testid={`PlatformAdminUI-UsersLink-HistorySection-CreatedDate-${formatStringToDate(
          createdDate,
          user,
        )}`}
      >
        Created {formatStringToDate(createdDate, user)}
      </div>
      <div
        className="Heading6 text-blue"
        data-testid={`PlatformAdminUI-UsersLink-HistorySection-UpdatedDate-${formatStringToDate(
          updatedDate,
        )}`}
      >
        Updated {formatStringToDate(updatedDate)}
      </div>
      {formatStringToDate(deactivatedDate) === '' ? (
        ''
      ) : (
        <div
          className="Heading6 text-blue"
          data-testid={`PlatformAdminUI-UsersLink-HistorySection-DeactivatedDate-${formatStringToDate(
            deactivatedDate,
          )}`}
        >
          Deactivated {formatStringToDate(deactivatedDate)}
        </div>
      )}
    </div>
  );
};
